module.exports = __webpack_public_path__ + "img/state0.d8b8cc40.png";